import { BaseEntryScope } from '@/apilib';
import { PublishManagerApiKey, EditorAPIKey } from '@/apis';
import { SeoAutoRedirectStore } from './store';

export class Scope extends BaseEntryScope {
  publishManagerApi = this.useDependency(PublishManagerApiKey);
  editorApi = this.useDependency(EditorAPIKey);
  store = this.declareStore(SeoAutoRedirectStore);
}
